import { render } from "./NavList.vue?vue&type=template&id=0842b112&scoped=true"
import script from "./NavList.vue?vue&type=script&lang=js"
export * from "./NavList.vue?vue&type=script&lang=js"

import "./NavList.vue?vue&type=style&index=0&id=0842b112&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0842b112"]])

export default __exports__